"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    edit: 'Edit',
    remove: 'Remove',
    addAnother: 'Add Another',
    next: 'Next',
    previous: 'Previous',
    cancel: 'Cancel',
    loading: 'Loading',
    help: 'Help',
    component: 'Component',
    save: 'Save',
    preview: 'Preview',
    dragAndDropComponent: 'Drag and Drop a form component',
    searchFields: 'Search field(s)',
    noMatchesFound: 'No Matches Found',
    fileName: 'File Name',
    size: 'Size',
    type: 'Type',
    gallery: 'Gallery',
    camera: 'Camera',
    dropFilesToAttach: 'Drop files to attach,',
    useCamera: 'Use Camera',
    browse: 'browse',
    takePicture: 'Take Picture',
    switchToFileUpload: 'Switch to file upload',
    completeStatus: 'Complete',
    noStorageSet: 'No storage has been set for this field. File uploads are disabled until storage is set up.',
    noFileApiSupport: 'File API & FileReader API not supported.',
    noFormDataSupport: "XHR2's FormData is not supported.",
    noProgressSupport: "XHR2's upload progress isn't supported.",
    close: 'Close',
    addResource: 'Add Resource',
    autocomplete: 'autocomplete',
    showPreview: 'Show preview',
    hidePreview: 'Hide preview',
    createPage: 'Create Page',
    page: 'Page',
    closeBtnDescription: 'Close button. Click to get back to the form',
    cancelBtnDescription: 'Cancel button. Click to cancel the changes and get back to the form.',
    saveBtnDescription: 'Save button. Click to save the changes and get back to the form.',
    addOrRemove: 'Add/Remove',
    anyFileTypesAllowed: 'Any file types are allowed',
    allowedFileTypes: 'Allowed file types',
    syncing: 'Syncing...',
    syncNow: 'Sync Now',
    pressToOpen: 'Press to open',
    browseToAttachFileFor: 'Browse to attach file for',
    or: 'or',
    numericOnly: 'numeric only',
    uploadPdfFile: 'Upload a PDF File',
    dropToStart: 'Drop pdf to start, or',
    expand: 'Expand',
    collapse: 'Collapse',
    add: 'Add',
    delete: 'Delete',
    revert: 'Revert',
    removeBtnPressToRemove: 'Remove button. Press to remove',
    file: 'file',
    captureVideo: 'Capture Video',
    captureAudio: 'Capture Audio',
    captureImage: 'Capture Image',
    browseFiles: 'Browse Files',
    noComponentsSetInGrid: 'No components have been set up to display in the Data Table. "Table View" must be checked for components to render.',
    sortAscending: 'Sort Ascending',
    sortDescending: 'Sort Descending',
    filter: 'Filter',
    clear: 'Clear',
    showItemsWithValue: 'Show items with value that:',
    gridItemsPerPage: 'Items per page:',
    gridAllItems: 'All',
    recordsSelectedOnPage: 'records on this page are selected.',
    recordsSelectedInTable: 'records in the table are selected.',
    gridSelectAll: 'Select all',
    itemsInTable: 'items in the table.',
    clearSelection: 'Clear selection.',
    editGridRow: 'Edit row',
    deleteGridRow: 'Delete row',
    selected: 'selected',
    actions: 'Actions',
};
